import { cn } from "@/utils/cn";

// Steel-styled surface card. Renders as any element via `as` (e.g. "button").
export const Card = ({ as: Tag = "div", className = "", children, ...props }) => (
  <Tag className={cn("steel-card rounded-xl", className)} {...props}>
    {children}
  </Tag>
);
